// discovering feature

export const DISCOVERING_FEATURE_VISIBILITY_DAYS = 30;

export const FILE_ACCESS_SETTINGS_BUTTON_ID = 'file-access-settings-button';

// TODO: check release dates and remove them after 30 days
// fourth release date for discovering feature: 2026-06-16
export const FOURTH_RELEASE_DISCOVERING_FEATURE = '2026-06-16'; // TODO: remove when time comes

export const FIFTH_RELEASE_DISCOVERING_FEATURE = '2026-07-15'; // TODO: remove when time comes
